module.exports = __webpack_public_path__ + "img/photo-4-1.707e39d6.webp";